"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TableHead = _interopRequireDefault(require("./TableHead"));

var _TableToolbar = _interopRequireDefault(require("./TableToolbar"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
}

function stableSort(array, cmp) {
  var stabilizedThis = array.map(function (el, index) {
    return [el, index];
  });
  stabilizedThis.sort(function (a, b) {
    var order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(function (el) {
    return el[0];
  });
}

function getSorting(order, orderBy) {
  return order === 'desc' ? function (a, b) {
    return desc(a, b, orderBy);
  } : function (a, b) {
    return -desc(a, b, orderBy);
  };
}

function getRowsPerPage() {
  var sh = window.innerHeight;
  var sw = window.innerWidth;
  var rows = sw < 600 ? Math.round((sh - 256) / 56) : Math.round((sh - 367) / 48);
  rows = rows < 1 ? 1 : rows;
  return rows;
}

var styles = function styles(theme) {
  return {
    root: {
      width: '100%'
    },
    tableWrapper: {
      overflowX: 'auto'
    }
  };
};

var EnhancedTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EnhancedTable, _React$Component);

  function EnhancedTable(props) {
    var _this;

    _classCallCheck(this, EnhancedTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EnhancedTable).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleScreenResize", function () {
      _this.setState(function () {
        return {
          onMobile: window.innerWidth < 600,
          rowsPerPage: getRowsPerPage()
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestSort", function (event, property) {
      var orderBy = property;
      var order = 'desc';

      if (_this.state.orderBy === property && _this.state.order === 'desc') {
        order = 'asc';
      }

      _this.setState({
        order: order,
        orderBy: orderBy
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangePage", function (event, page) {
      _this.setState({
        page: page
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeRowsPerPage", function (event) {
      _this.setState({
        rowsPerPage: event.target.value
      });
    });

    _this.state = {
      onMobile: window.innerWidth < 600,
      order: props.order ? props.order : 'asc',
      orderBy: props.columns[0].id,
      page: 0,
      rowsPerPage: getRowsPerPage()
    };
    return _this;
  }

  _createClass(EnhancedTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleScreenResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleScreenResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          columns = _this$props.columns,
          title = _this$props.title,
          tooltip = _this$props.tooltip,
          tooltipAction = _this$props.tooltipAction;
      var _this$state = this.state,
          onMobile = _this$state.onMobile,
          order = _this$state.order,
          orderBy = _this$state.orderBy,
          page = _this$state.page,
          rowsPerPage = _this$state.rowsPerPage;
      var data = this.props.data;
      var emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
      var filteredColumns = columns.filter(function (column) {
        return !column.hideOnMobile || !onMobile;
      });
      return _react["default"].createElement("div", {
        className: classes.root
      }, _react["default"].createElement(_TableToolbar["default"], {
        title: title,
        tooltip: tooltip,
        tooltipAction: tooltipAction
      }), _react["default"].createElement("div", {
        className: classes.tableWrapper
      }, _react["default"].createElement(_Table["default"], {
        "aria-labelledby": "tableTitle"
      }, _react["default"].createElement(_TableHead["default"], {
        onMobile: onMobile,
        order: order,
        orderBy: orderBy,
        onSelectAllClick: this.handleSelectAllClick,
        onRequestSort: this.handleRequestSort,
        rowCount: data.length,
        columns: filteredColumns
      }), _react["default"].createElement(_TableBody["default"], null, stableSort(data, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (n, i) {
        return _react["default"].createElement(_TableRow["default"], {
          hover: true,
          tabIndex: -1,
          key: i
        }, filteredColumns.map(function (column, j) {
          return _react["default"].createElement(_TableCell["default"], {
            align: column.align,
            key: j,
            padding: column.padding ? column.padding : 'default'
          }, column.component ? _react["default"].createElement(column.component, {
            callback: column.callback,
            value: n[column.id],
            id: n.id
          }) : n[column.id]);
        }));
      }), emptyRows > 0 && _react["default"].createElement(_TableRow["default"], {
        style: {
          height: 49 * emptyRows
        }
      }, _react["default"].createElement(_TableCell["default"], {
        colSpan: 6
      }))))), _react["default"].createElement(_TablePagination["default"], {
        component: "div",
        count: data.length,
        labelRowsPerPage: "Filas",
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [getRowsPerPage(), 25, 50, 100],
        page: page,
        backIconButtonProps: {
          'aria-label': 'Previous Page'
        },
        nextIconButtonProps: {
          'aria-label': 'Next Page'
        },
        onChangePage: this.handleChangePage,
        onChangeRowsPerPage: this.handleChangeRowsPerPage
      }));
    }
  }]);

  return EnhancedTable;
}(_react["default"].Component);

EnhancedTable.propTypes = {
  classes: _propTypes["default"].object.isRequired
};

var _default = (0, _styles.withStyles)(styles)(EnhancedTable);

exports["default"] = _default;